"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.divide = void 0;
const divide = ({ leftValue, rightValue, }) => {
    if (typeof leftValue !== 'number' || typeof rightValue !== 'number') {
        return {
            error: `Division error: inputs must be numbers, received: [${leftValue}, ${rightValue}]`,
        };
    }
    if (rightValue === 0) {
        return {
            error: `Division error: attempted to divide by 0, inputs: [${leftValue}, ${rightValue}]. Consider wrapping with IFERROR if denominators with 0 values are expected scenarios for this formula.`,
        };
    }
    const result = leftValue / rightValue;
    return { error: null, result };
};
exports.divide = divide;
//# sourceMappingURL=divide.js.map